import {createContext, useContext, useState} from "react";

const DivisionContext  = createContext();

export const DivisonProvider = ({ children }) => {
    const[division, setDivision] = useState(localStorage.getItem('userDivision') || '');

    return(
        <DivisionContext.Provider value={{ division, setDivision}}>
            {children}
        </DivisionContext.Provider>
    );
};

export const useDivision = () => useContext(DivisionContext);

